<template>
  <VaForm
    ref="formRef"
    class="w-full max-w-xl flex flex-col md:flex-row gap-4 mt-2"
    @submit.prevent="submit"
  >
    <VaInput
      v-model="term"
      class="w-full"
      :placeholder="t('podcasts.search.placeholder')"
      :rules="rules.term"
      :max-length="255"
    />
    <VaButton class="flex-shrink-0" size="large" :loading="loading" @click="submit">
      {{ submitLabel }}
    </VaButton>
  </VaForm>
</template>

<script lang="ts" setup>
import { useForm, VaButton, VaForm, VaInput } from 'vuestic-ui'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps<{
  loading: boolean
  submitLabel: string
}>()

const emit = defineEmits<{
  (e: 'search', term: string): void
}>()

const { t } = useI18n()

const formRef = ref()
const term = ref('')
const { validate } = useForm(formRef)

const rules = {
  term: [(v: string) => v?.trim().length >= 2 || t('podcasts.search.required')],
}

const submit = () => {
  if (!validate()) return
  emit('search', term.value.trim())
}
</script>
